import * as actions from './actions';
import { handle } from './service';
import { ACTION_KEY, ServiceMethod } from './types';

export { actions };

export {
  IManualTranscript as ManualTranscript,
  ITranscript as RecordingTranscript,
  TranscriptNotFoundError,
} from './types';

export default {
  handle,
  ActionKey: ACTION_KEY,
  Method: ServiceMethod,
};
